// src/hooks/transportations/useDeleteTransportation.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteTransportation } from "../../api/apiTransportations";
import parseError from "../../utils/parseError";

const useDeleteTransportation = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteTransportationMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: deleteTransportation,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["transportations"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete transportation");
        },
    });

    return {
        deleteTransportation: deleteTransportationMutate,
        isDelete: isPending || isLoading,
    };
};

export default useDeleteTransportation;
